import * as c from '.'
import Home from '../pages/Home'
import ThankYou from '../pages/ThankYou'
import PrivacyPolicy from '../pages/PrivacyPolicy'
import Page404 from '../pages/Page404'

const setRoute = ({path, name, component, icon, isHidden}) => {
  return {path, name, component, icon, isHidden}
}

const getRoutes = () => {
  return [
    setRoute({
      path: c.LINK_HOME,
      name: `Registration Form`,
      component: Home
    }),
    setRoute({
      path: c.LINK_THANK_YOU,
      name: `Thank You`,
      component: ThankYou
    }),
    setRoute({
      path: c.LINK_PRIVACY_POLICY,
      name: `Privacy Policy`,
      component: PrivacyPolicy
    }),
    setRoute({
      path: c.LINK_404,
      name: `404`,
      component: Page404,
      isHidden: true
    }),
  ]
}

export default getRoutes
